import { useEffect, useRef } from "react";
import useForm from "./useForm";
import { getPath } from "../../utils/objectPath";

function useField(componentName, _ref) {
  var name = _ref.name,
      disabled = _ref.disabled,
      optional = _ref.optional,
      validate = _ref.validate,
      data = _ref.data;

  if (typeof name !== "string" || name.trim() === "") {
    throw new Error("".concat(componentName, " component is missing a name prop"));
  }

  var _useForm = useForm(componentName),
      state = _useForm.state,
      onFocus = _useForm.onFocus,
      onBlur = _useForm.onBlur,
      onChange = _useForm.onChange,
      onMouseDown = _useForm.onMouseDown,
      registerField = _useForm.registerField,
      unregisterField = _useForm.unregisterField;

  var registerDataRef = useRef({
    registerField: registerField,
    unregisterField: unregisterField,
    name: name,
    disabled: disabled,
    optional: optional,
    validate: validate,
    data: data
  });

  if (typeof state.values === "undefined") {
    throw new Error("Form is missing initialValues");
  }

  var value = getPath(state.values, name);

  if (typeof value === "undefined") {
    throw new Error("".concat(name, " is missing in Form's initialValues"));
  }

  var errors = getPath(state.errors, name);
  var hasErrors = Array.isArray(errors) && errors.length > 0; // we need to store the data in a ref so that if the validateData prop changes, we have a reference
  // that we can update with the new value.

  useEffect(function () {
    registerDataRef.current = {
      registerField: registerField,
      unregisterField: unregisterField,
      name: name,
      disabled: disabled,
      optional: optional,
      validate: validate,
      data: data
    };
  }, [name, disabled, optional, validate, data, registerField, unregisterField]);
  useEffect(function () {
    registerField(name, registerDataRef);
    return function () {
      unregisterField(name);
    };
  }, [registerField, unregisterField, name]);
  return {
    value: value,
    errors: errors,
    hasErrors: hasErrors,
    onFocus: onFocus,
    onBlur: onBlur,
    onChange: onChange,
    onMouseDown: onMouseDown
  };
}

export default useField;